import Swiper from "swiper";
import { Scrollbar } from "swiper/modules";

document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".swiper.core-values-slider")) return;

  const swiper = new Swiper(".swiper.core-values-slider", {
    modules: [Scrollbar],
    slidesPerView: 1,
    spaceBetween: 32,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
    },
  });
});
